import { skipToken } from '@reduxjs/toolkit/query/react';

import { templatesApi } from 'apis/templates';

import { Item, ListItem } from '../listItem/listItem';

export type AutoRepliesExceptionListItemProps = {
  item: Item;
};

export function AutoRepliesExceptionListItem({
  item,
}: AutoRepliesExceptionListItemProps): JSX.Element {
  const { template, isLoading } = templatesApi.useReadTemplateByIdQuery(
    item.value?.label ? { id: item.value?.label } : skipToken,
    {
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        template: data?.data,
      }),
    },
  );

  const updatedItem: Item = {
    ...item,
    value: {
      label: template ? template?.name : '',
    },
  };

  return (
    <ListItem
      key={updatedItem.name}
      item={updatedItem}
      isLoading={isLoading}
    ></ListItem>
  );
}
